export default __webpack_public_path__ + "static/media/person-charac01.60b87630.png";